export default __webpack_public_path__ + "static/media/element_82.960747b1.avif";